/** @jsx h */
import { h } from 'preact'

import ModalCardHeader from './Header'
import ExternalLink from '../ExternalLink'
import t from '../../../utils/translate'

const EvidenceVerifierSection = ({ claimName, description, avatarUrl, eventLabel, verifierName, href, claimStatus }) =>
  <section class='ModalCard-section'>
    <p class='ModalCard-heading ModalCard-heading--claim'>
      {t('proof_points.js.evidence.verified_by', { claimName })}
    </p>
    <ModalCardHeader title={verifierName} imageUrl={avatarUrl} claimStatus={claimStatus} />
    <p class='ModalCard-para u-marginTop16'>{description}</p>
    {href &&
      <ExternalLink href={href} class='u-marginTop16' linkName='View verifier' analyticsContext={eventLabel}>
        {t('proof_points.js.evidence.view_verifier')}
      </ExternalLink>}
  </section>

export default EvidenceVerifierSection
